/**
 * @author: Radim Buráň <xburan03@stud.fit.vutbr.cz>
 */

import './../AuctionDetail.css';
import {useEffect} from "react";
import { useState } from "react";

import Paper from '@mui/material/Paper';
import Box from "@mui/material/Box";
import {Grid} from "@mui/material";


function DescriptionPanel(props) {
    const [desc, setDesc] = useState("")

    useEffect(()=> {
        if (props.isLoaded) {
            setDesc(props.auction.description);
        }
    },[props.auction, props.isLoaded]);


    function getInfoPaper(key1, value1, key2, value2) {
        return (
            <Paper key={key1+key2} elevation={6} sx={{ width: 1/4.2, minWidth: 250, marginBottom: 5}}>
                <Grid container>
                    <Grid item xs={5} sx={{padding: 2}}>
                        <p>{key1}</p>
                    </Grid>

                    <Grid item xs={7} sx={{padding: 2}}>
                        <p>{value1}</p>
                    </Grid>

                    <Grid item xs={5} sx={{padding: 2}}>
                        <p>{key2}</p>
                    </Grid>

                    <Grid item xs={7} sx={{padding: 2}}>
                        <p>{value2}</p>
                    </Grid>
                </Grid>
            </Paper>
        );
    }


    function getOfferTranslation(offer) {
        if (offer === "DEMAND") {
            return "Poptávková";
        }
        else {
            return "Nabídková";
        }
    }

    function getTypeTranslation(type) {
        if (type === "OPEN") {
            return "Otevřená";
        }
        else {
            return "Uzavřená";
        }
    }

    function getInfoPanels() {
        const comps = [];
        if (props.auction) {
            if (props.auction.createdBy) {
                comps.push(getInfoPaper(
                    "Založil:", props.auction.createdBy.name,
                    "Email:", props.auction.createdBy.email
                ));
            }

            comps.push(getInfoPaper(
                "Typ:", getTypeTranslation(props.auction.type),
                "Styl:", getOfferTranslation(props.auction.offerType)
            ));

            comps.push(getInfoPaper(
                "Začátek:", new Date(props.auction.startAt).toLocaleString('cs-CZ'),
                "Konec:", new Date(props.auction.endAt).toLocaleString('cs-CZ')
            ));

            comps.push(getInfoPaper(
                "Kategorie:", props.auction.category.title,
                "Vyvolávací cena:", props.auction.startPrice + " Kč"
            ));
        }

        return comps;
    }



    if (!props.isLoaded) {
        return "";
    }

    return (
        <Box sx={{width: 1, boxSizing: "border-box" }}>

            <Box sx={{ width: 1, marginTop: 5, boxSizing: "border-box",
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: "row",
                justifyContent: "space-between"
            }}>
                {getInfoPanels()}

            </Box>


            <Paper elevation={6} sx={{ padding: 2, width: 1, marginBottom: 5, boxSizing: "border-box" }}>
                <p>{desc}</p>
            </Paper>
        </Box>
    );

}

export default DescriptionPanel;